module.exports = __webpack_public_path__ + "74e85996a3fbd1da0409898ef53bbc83.mp3";


//////////////////
// WEBPACK FOOTER
// ./assets/sounds/dances/tango.mp3
// module id = 4155
// module chunks = 0